import * as types from "./types";

const initialState = {
  rows: [],
  loading: false,
  error: null,
};

export default function auditReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_AUDIT_ROWS:
      return {
        ...state,
        rows: action.payload,
      };
    default:
      return state;
  }
}
